import styles from "./Layout.module.css";

// react
import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";

// components
import Footer from "./Footer";
import NavBar from "./NavBar";

// context
import { useContext } from "react";
import { MyContext } from "components/RoleContext";
import { Role } from "tools/Enums";

export default function Layout({ children }) {
	const { role } = useContext(MyContext);

	return (
		<>
			{role !== Role.Unauthorized && (
				<div className={styles.grid} style={{ height: window.innerHeight }}>
					<NavBar />
					<main className={styles.content}>{children}</main>
					<Footer />
				</div>
			)}

			{/* User not authorized is redirected to Login Page */}
			{role === Role.Unauthorized && <Redirect to="/" />}
		</>
	);
}
